import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { Contribution } from 'src/app/model/contrib.model';
import { ContributionCoord } from 'src/app/model/contrib-coord.model';
import { environment } from 'src/environments/environment';
import { Tile } from 'src/app/model/tile.model';

@Injectable({
  providedIn: 'root',
})
export class ContributionsService {
  private readonly BASE_API = environment.apiUrl;

  constructor(private readonly http: HttpClient) {}

  createContributions(contributions: Contribution[]): Observable<Contribution[]> {
    return this.http.post<Contribution[]>(`${this.BASE_API}/api/contributions`, contributions);
  }

  createContributionsCoord(contributions: ContributionCoord): Observable<ContributionCoord> {
    return this.http.post<ContributionCoord>(
      `${this.BASE_API}/api/contributionsCoord`,
      contributions,
    );
  }

  getNext(lastEvaluatedKey: string, wanted: string): Observable<Tile> {
    return this.http.get<Tile>(
      `${this.BASE_API}/api/contributions?lastEvaluatedKey=${lastEvaluatedKey}&wanted=${wanted}`,
    );
  }

  getAllContribs(): Observable<{ Items: Tile[] }> {
    return this.http.get<{ Items: Tile[] }>(`${this.BASE_API}/api/contributions?wanted=all`);
  }

  resolveContribution(
    contribution: Contribution,
    hasPool: boolean,
    geojson: any,
    imageInfos: {
      usedLabels: string[];
      labels_used: any;
    },
  ): Observable<Contribution> {
    return this.http.put<Contribution>(
      `${this.BASE_API}/api/contributions/${contribution.tile.id}`,
      { ...contribution, hasPool, geojson, imageInfos },
    );
  }

  askAi(contribution: Contribution): Observable<string> {
    return this.http.post<string>(`${this.BASE_API}/api/sagemaker`, contribution);
  }
}
